<template>
	<div class="theGefaultGroup">
		<div class="header">
		<!-- 分页 -->
		 <el-pagination
			class="paging"
			background
			@size-change="handleSizeChange"
			@current-change="handleCurrentChange"
			:current-page.sync="form.pageNo"
			:page-size="form.pageSize"
			layout="total, prev, pager, next"
			:pager-count="7"
			:total="form.totalCount">
		  </el-pagination>
		</div>
		<div :style="{height:tableHeight - 70 +'px'}">
			<el-table
			:maxHeight="tableHeight - 70 + 'px'"
			 size="small"
			ref="multipleTable"
			:data="form.Groupinglist"
			tooltip-effect="dark"
			border
			>
			<el-table-column label="名称">
				<template slot-scope="scope">
					{{ scope.row.name }}
				</template>
			</el-table-column>
			<el-table-column prop="npsKey" label="Key"></el-table-column>
			<el-table-column prop="groupDesc" label="描述"></el-table-column>
			<el-table-column label="时间"  width="120" align="center">
				<template slot-scope="scope">
					{{formatCreateDate(scope.row.createDate)}}
				</template>
			</el-table-column>
			<el-table-column label="操作" width="120" align="center">
				<template scope="scope">
					<el-button  type="danger" v-if="scope.row.defaultreturn == 1"   size="small"  @click="Enable(scope.row,2)">取消默认</el-button>
				</template>
			</el-table-column>
			</el-table>
			</div>
	</div>
</template>

<script>
  import api from '@/api/menu/'
  import { mapState } from 'vuex';
  export default {
    props: {
      terminalId: {
        type: String
      },
    },
    computed: {
      ...mapState('main', ['tableHeight'])
    },
    data() {
        return {
			 form: { //分组
				Groupinglist:[], //列表
				groupDesc:'',//描述
				groupValue:'',//参数
				editlyAddedKey:'',  //key
				defaultreturn:1, //1启用 禁用0
				pageSize:15,
				pageNo: 1,//当前页码
				totalCount: 0,//总条数
				querySertitleName:'',
				token:'',
			},
		}
    },
    created() {
      // this.form.token = this.$cookies.get('USER_TOKEN_COOKIE');

      this.querygroup();
    },
    methods: {
		// 时间格式
		formatCreateDate: function(row) {
		  return window.formatDate(row);
		},
		// 启用 禁用分组
		Enable(src,defaultreturn){
			this.defaultreturn = defaultreturn;
			var data = {
			  'groupId':src.id,
			  'token':this.form.token,
			  'defaultreturn':defaultreturn
			};
			api.setgroupDefaultReturn(data)
				.then(res => {
					if(res.data.code == 0){
						this.querygroup();
					}else{
						errorMsg({
							   message: res.data.msg
						})
					}
				})
		},
		
		// 11.9 查询分组
		querygroup(){
			this.form.Groupinglist = [];
			var data = {
			  'terminalId':this.terminalId,
			  'pageNo':this.form.pageNo,
			  'pageSize':this.form.pageSize,
			  // 'type':this.form.type,
			  'name':this.form.querySertitleName,
			  'token':this.form.token,
			  'groupValue':this.form.groupValue,
			  'groupDesc':this.form.groupDesc,
			  'key':this.form.editlyAddedKey,
			  'defaultreturn':"1"
			};
		 api.querygroup(data)
			.then(res => {
				if(res.data.code == 0){
					this.form.Groupinglist = res.data.data.list;
					// this.formStrand.strandlistName = res.data.data.list;
					this.form.totalCount = res.data.data.totalSize;
				}else{
					errorMsg({
						   message: res.data.msg
					})
				}
			})
		},

      //改变每页显示数量时调用
      handleSizeChange(val) {
        this.$nextTick(() =>
          this.querygroup(),
        )
      },
      //点击下一页和点击页码时执行
      handleCurrentChange(val) {
        this.querygroup();
      },
    }
  };
</script>

<style scoped lang="less">
	.theGefaultGroup{
		  .crumbs {
		    margin-top: 10px;
		  }
		  .header {
		    position: relative;
		    height: 42px;
			// margin-bottom: 40px;
		    // line-height: 60px;
		    .paging{
		      position: absolute;
		      right: 0px;
		      top: 0px;
			  
		    }
		    .search {
		      width: 200px;
		    }
		  }
		  .a {
		    cursor: pointer;
		  }
		
	}
</style>
